import { openDialog } from 'vue3-promise-dialog'
import RefreshSessionDialog from './RefreshSessionDialog.vue'
import PDFPreviewerDialog from './PDFPreviewerDialog.vue'
import RegenerateReportDialog from './RegenerateReportDialog.vue'
import ClientUploadsDialog from './ClientUploadsDialog.vue'
import AnnualQuestionnairePreviewDialog from './AnnualQuestionnairePreviewDialog.vue'
import AnnualQuestionnaireDialog from './AnnualQuestionnaireDialog.vue'
import CreateNewAccountDialog from './CreateNewAccountDialog.vue'
import DeathClaimTrackerListViewDialog from '../DeathClaimTracker/DeathClaimTrackerListViewDialog.vue'
import ClientRolePropertiesDialog from './ClientRolePropertiesDialog.vue'

export const confirmRefreshSession = async (seconds) => {
  return await openDialog(RefreshSessionDialog, { seconds })
}

export const openPDFPreviewer = async (pdfData, fileName) => {
  return await openDialog(PDFPreviewerDialog, { pdfData, fileName })
}

export const confirmRegenerateReport = async () => {
  return await openDialog(RegenerateReportDialog, {})
}

export const openClientUploadsDialog = async () => {
  return await openDialog(ClientUploadsDialog, {})
}

export const openAnnualQuestionnairePreviewDialog = async (rawData) => {
  return await openDialog(AnnualQuestionnairePreviewDialog, { rawData })
}

export const openAnnualQuestionnaireDialog = async (rawQuestionnaireData) => {
  return await openDialog(AnnualQuestionnaireDialog, { rawQuestionnaireData })
}

export const openDeathClaimTrackerListViewDialog = async (status) => {
  return await openDialog(DeathClaimTrackerListViewDialog, { status })
}

export const openCreateNewAccountDialog = async () => {
  return await openDialog(CreateNewAccountDialog, {})
}

export const openClientRolePropertiesDialog = async (newAccountData) => {
  return await openDialog(ClientRolePropertiesDialog, { newAccountData })
}
